<template>
    <div class="ag-page_assets position-relative">
        <div class="ag-content ag-card">
            <div class="ag-card_header d-flex align-items-center">
                <div class="ag-card_navigation">
                    <ul class="nav">
                        <li class="nav-item d-flex align-items-center">
                            <a aria-current="page" href="#" class=" router-link-active router-link-exact-active
                            nav-item
                            pt-3
                            pb-3
                            pl-4
                            pr-4
                            d-block d-flex
                            align-items-center
                            active ">
                                {{ $t("companyList") }}
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="ag-card_buttons d-flex ml-auto mr-3" style="width: 15rem;">
                    <div class="input-group">
                        <span class="input-group-prepend">
                            <div class="input-group-text bg-transparent border-right-0">
                                <i class="ag-icon ag-icon_darkSearch"></i>
                            </div>
                        </span>
                        <input class="form-control py-2 border-left-0 border" v-model="globalSearch" type="search"
                            placeholder="Search..." />
                    </div>
                </div>
                <div class="ag-card_buttons d-flex">
                    <a class="
              ag-button
              btn-sm
              ml-2
              d-inline-flex
              align-items-center
              ag-button_primary
              mr-3
            " style="cursor: pointer;" id="btnNewCompany" @click="openCompanyModal">
                        <i class="ag-icon mr-1 ag-icon_add"></i> {{ $t("newCompany") }}
                    </a>
                </div>
            </div>
            <div v-if="isCompanyModalVisible" class="modal">
                <ag-company-modal ref="companyModal" @close-popup="closeCompanyModal"
                    @company-list-updated="handleListUpdated" />
            </div>
            <div class="ag-card_body">
                <ag-loading v-if="loading" class="ag-loading" />
                <div v-if="!loading" class="m-3">
                    <DataTable v-model="filteredCompany" paginator ref="dataTable" :rows="rowsPerPage"
                        :value="filteredCompany" dataKey="id" size="small" :currentPage="currentPage"
                        :rowsPerPageOptions="[5, 10, 20, 50]"
                        paginatorTemplate="CurrentPageReport RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                        currentPageReportTemplate="{totalRecords} Results" sortField="companyName" :sortOrder="1">
                        <Column field="companyName" :header="$t('companyname')" :sortable="true" headerStyle="width:20rem">
                            <template #body="slotProps">
                                <div class="d-flex align-items-center">
                                    <img src="/logo-circle.svg" width="19" height="19" />
                                    <a @click="goToCompany(slotProps.data)" class="cursor company-name">
                                        {{ slotProps.data.companyName }}
                                    </a>
                                </div>
                            </template>
                        </Column>
                        <Column field="fullAddress" :header="$t('companyAddress')" headerStyle="width:20rem">
                        </Column>
                        <Column field="licenseStatus" :header="$t('licenseStatus')" headerStyle="width:20rem">
                            <template #body="slotProps">
                                <div :style="getLicenseStatus(slotProps.data).style"
                                    @click="goToLink('/administration/manage-license')" class="cursor">
                                    {{ getLicenseStatus(slotProps.data).text }}
                                </div>
                            </template>
                        </Column>
                        <Column :header="$t('actions')" headerStyle="width:10rem">
                            <template #body="slotProps">
                                <div>
                                    <Button icon="ag-icon ag-icon_edit" class="icon" size="small"
                                        :title="$t('editCompany')" outlined @click="editCompany(slotProps.data)" />
                                        <Button icon="ag-icon ag-icon_delete" :id="`${slotProps.data.companyName}btnDelete`" class="delete-icon"
                                            :title="$t('deleteCompany')" outlined
                                            @click="removeCompany(slotProps.data.companyGuid)" />
                                </div>
                            </template>
                        </Column>
                        <template #empty>
                            <div class="text-center mt-3">
                                <p>{{ $t("noCompaniesFound") }}</p>
                            </div>
                        </template>
                    </DataTable>
                </div>
            </div>
        </div>
    </div>
    <iframe :src="agmsUrlForCompany" @load="onLoadIframe" frameborder="0" width="0px" height="0px"
        v-if="agmsUrlForCompany"></iframe>
</template>

<script>
import AgLoading from "@/components/ag-loading/index.vue";
import { notify } from "@kyvg/vue3-notification";
import AgCompanyModal from "@/components/ag-company-modal/index.vue";
import axiosApi from "@/store/axiosAgsc";
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import { useStore } from "@/store";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { mapActions, mapGetters } from "vuex";
import { AuthActionTypes } from "@/store/modules/auth/action-types";
import { Roles } from "@/helpers/enums/Roles";

const store = useStore();
let selectedPartner = localStorage.getItem("partner");
let partner = JSON.parse(selectedPartner);
console.log(localStorage)
localStorage.setItem("selectedRole", Roles.PartnerAdmin);
localStorage.setItem("selectedScopeId", partner.guid);
localStorage.setItem("company", "");
 const setCompany = {
        selected: true,
        agms: false,
 };
localStorage.setItem("company", JSON.stringify(setCompany));
export default {
    components: {
        AgCompanyModal,
        AgLoading,
    },

    data() {
        return {
            isCompanyModalVisible: false,
            loading: true,
            tableData: [],
            role: null,
            globalSearch: null,
            currentPage: 1,
            rowsPerPage: 20,
            response: {},
            selectedCompanyData: null,
            agmsUrlForCompany: null
        };
    },

    computed: {
        filteredCompany() {
            if (!this.globalSearch) {
                return this.response;
            }
            const searchTerm = this.globalSearch.toLowerCase();
            return this.response.filter(company =>
                company.companyName.toLowerCase().includes(searchTerm)
            );
        }
    },

    async created() {
        await this.getList();
    },

    methods: {
        ...mapActions({
            setCompany: AuthActionTypes.SET_COMPANY,
        }),

        closeCompanyModal() {
            this.isCompanyModalVisible = false;
        },

        async deleteCompany(companyGuid) {
            try {
                const data = { id: companyGuid }
                const res = await store.dispatch(GeneralActionTypes.DELETE_COMPANY, data);

                if (res && res.statusCode == 200 && res.isSuccess) {
                    await this.getList();
                    notify({
                        title: this.$t("companyDeleted"),
                        type: 'success',
                        duration: 4000,
                    });
                } else {
                    notify({
                        title: this.$t("error"),
                        type: "error",
                        text: res.Message,
                        duration: 8000,
                    });
                }
            } catch (error) {
                notify({
                    title: this.$t("error"),
                    type: "error",
                    text: error,
                    duration: 8000,
                });
            } finally {
                this.loading = false;
            }
        },

        editCompany(company) {
            this.isCompanyModalVisible = true;
            this.$nextTick(() => {
                const companyModal = this.$refs.companyModal;

                if (companyModal) {
                    companyModal.editCompany(company);
                } else {
                    console.error("Ref companyModal not found");
                }
            });
        },

        getLicenseStatus(company) {
            const currentDateTime = new Date();
            const expirationDate = new Date(company.licenseExpDate);

            if (company.licenseStatus === "Active") {
                if (expirationDate >= currentDateTime) {
                    return {
                        status: "Active",
                        style: { color: "green" },
                        text: this.$t('licenseIsActivated')
                    };
                } else {
                    return {
                        status: "Expired",
                        style: { color: "red" },
                        text: this.$t('licenseIsExpired')
                    };
                }
            } else if (company.licenseStatus === "Deactivated") {
                return {
                    status: "Deactivated",
                    style: { color: "red" },
                    text: this.$t('licenseIsDeactivated')
                };
            } else {
                return {
                    status: "NotActivated",
                    style: { color: "orange" },
                    text: this.$t('licenseIsNotActivated')
                };
            }
        },

        async getList() {
            try {
                await axiosApi
                    .get(
                        `Company/ManageCompany?partnerId=${partner.guid}`
                    )
                    .then((res) => {
                        if (res.data && res.data.statusCode == 200 && res.data.isSuccess) {
                            this.response = res.data.entityData;
                            if (localStorage.manageCompany) {
                                let manageCompany = localStorage.getItem("manageCompany");
                                let manageCompanyAgms = JSON.parse(manageCompany);

                                if (manageCompanyAgms.name === "newCompany") {
                                    this.openCompanyModal();
                                } else if (manageCompanyAgms.name === "editCompany") {
                                    const editedCompany = this.response.find(company => company.companyGuid === manageCompanyAgms.companyGuid);
                                    this.editCompany(editedCompany);
                                } else if (manageCompanyAgms.name === "deleteCompany") {
                                    this.removeCompany(manageCompanyAgms.companyGuid);
                                }
                                localStorage.setItem("manageCompany", "");
                            }
                            this.loading = false;
                        } else {
                            notify({
                                title: this.$t("error"),
                                type: "error",
                                text: res.Message,
                                duration: 8000,
                            });
                        }
                    });
                setTimeout(() => {
                    this.loading = false;
                }, 350);
            } catch (error) {
                console.error('Error:', error);
                this.loading = false;
                notify({
                    title: this.$t("error"),
                    type: "error",
                    text: error,
                    duration: 8000,
                });
            }
        },

        goToLink(link) {
            this.$router.push(link);
        },

        goToCompany(company) {
            this.loading = true;
            localStorage.setItem("scopeChange", true);
            localStorage.setItem("selectedRole", Roles.CompanyAdmin);
            localStorage.setItem("selectedScopeId", company.companyGuid);
            localStorage.setItem("changingScope", true);
            const companyData = {
                companyGuid: company.companyGuid,
                companyId: company.mainId,
                companyName: company.companyName,
            };
            this.agmsUrlForCompany = process.env.VUE_APP_AGMS_URL +
                `/MultiTenant/ManageCompany/AGMSDashboard?companyId=${company.companyGuid}`;
            this.selectedCompanyData = companyData;
        },

        async handleListUpdated() {
            return await this.getList();
        },

        onLoadIframe() {
            this.agmsUrlForCompany = null;
            this.setCompany(this.selectedCompanyData);
            localStorage.setItem("company", JSON.stringify(this.selectedCompanyData));
            setTimeout(() => {
                location.href = "/dashboard/company-overview";
            }, 2000);
        },

        openCompanyModal() {
            this.isCompanyModalVisible = true;
        },

        removeCompany(companyGuid) {
            this.$swal
                .fire({
                    title: this.$t('areYouSure'),
                    icon: "warning",
                    text: this.$t('deleteCompany'),
                    showCancelButton: true,
                    confirmButtonText: "Delete",
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.loading = true;
                        this.deleteCompany(companyGuid);
                    }
                })
        },
    },
};
</script>

<style>
.p-paginator svg {
    width: 11px;
    height: 11px;
}

.p-paginator button,
.p-paginator .p-paginator-rpp-options,
.p-paginator .p-paginator-current {
    height: 30px;
}

.p-dropdown-item {
    font-size: 12px;
}

.p-paginator-bottom svg,
.p-paginator-current,
.paginatorwrapper .p-paginator-rpp-options span {
    color: #1878af !important;
}

.p-paginator-current {
    cursor: default;
}

.p-dropdown-item.p-highlight {
    background-color: #1878af !important;
}

.p-paginator .p-dropdown-label {
    font-size: 11px;
}

.p-paginator {
    justify-content: end !important;
    font-size: 11px;
}
</style>
<style scoped>
html {
    font-size: 12px;
}

.cursor {
    cursor: pointer;
    display: inline-block;
    max-width: 100%;
    white-space: nowrap;
}

.cursor:hover {
    color: #9F9F9F !important;
    text-decoration: none;
}

.company-name {
    padding-left: 5px;
     padding-top: 2px; 
     font-size: 18px; 
     font-weight: 600; 
     color: #3c8dbc;
}

:deep(.p-paginator .p-highlight) {
    background-color: #164B6C !important;
}

.delete-icon {
    border: 0;
    font-size: 11px;
    margin-bottom: 3px;
}

.icon {
    border: 0;
}

.italic {
    font-style: italic;
}

.modal {
    position: fixed;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    z-index: 1000000 !important;
}
</style>
